import { NhealthAction } from "./action.api";
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from "../utils/Encryption";
import liff from "@line/liff";
import lineConfig from "./authLine/lineConfig";
import { Base_API } from "./matcher";
import useLineLogin from "./authLine/lineLogin";
import { getMemberLab, isMembership } from "./lineoa.authen";
import { ALERT } from "../components/CustomAlert";

export {
    JWTAuthen,
    getJWTbyPatientID,
    getJWT_Patient,
    SignInPhone,
    authenAll,
    patientVerifySignIn,
    getPatient,
    updateKYCPatient,
    navigateCallbackURL,
    getHeadersAuthenLineId
}

const getPatient = (reqData, headers) => {
    return new Promise(async resolve => {

        NhealthAction.GetPatientProfile(reqData, headers)
        .then(res => {
            console.log('res: ', res);
            if(res.IsSuccess)
            {
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA, EncryptedOBJ(res))
                //! bypass
                resolve(res);
            }
        })
    })
}

const patientVerifySignIn = (reqData, headers) => {
    return new Promise(async resolve => {
        NhealthAction.PatientVerifySignIn(reqData, headers)
        .then(res => {
            if(res.IsSuccess)
            {
                resolve(res);
            }
        })
    })
}

const JWTAuthen = () => {
    return new Promise(async resolve => {
        let ip = await NhealthAction.GetIPAdress();
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        let udid = lineProfile.user_id;

        let reqData = {
            UserRef: udid,
            IPAddress: ip,
            Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
        } 

        NhealthAction.JWT_Authen(reqData)
        .then(res => {
            console.log('JWT: ', res);
            if(!!res)
            {
                resolve(res);
            }
        })
    })
}

const SignInPhone = (jwt, phoneNumber) => {
    return new Promise(async resolve => {
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        let udid = lineProfile.user_id;

        let reqData = {
            "data": EncryptedText(phoneNumber)
        }
        let headers = {
            headers: {
                Authorization: `Bearer ${jwt.token}`,
                userRef: udid,
                authorizeRef: jwt.authorizeRef,
                channalRef: jwt.channalRef
            }
        }
        NhealthAction.SignInPhone(reqData, headers)
        .then(res => {
            console.log(res);
            if(res.IsSuccess) 
            {
                resolve(res);
            }else
            {
                // show alert
            }
        })
    })
}

const navigateCallbackURL = () => {
    localStorage.removeItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL);
    localStorage.removeItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL);

    let callbackURLEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL)
    
    if(!!callbackURLEnc)
    {
        let callbackURLDec = DecryptedText(callbackURLEnc);
        console.log('callbackURLDec: ', callbackURLDec);
        if(callbackURLDec.indexOf('/ref') >= 0)
        {
            let refRedirect = !!localStorage.getItem('refredirect') ? DecryptedText(localStorage.getItem('refredirect')) : null;
            let newCallbackURL = callbackURLDec.replace('/ref', `/${refRedirect}`)
            let path = newCallbackURL;
            location.href = path; 
        }else
        {
            let path = callbackURLDec;
            location.href = path;
        }
    }   
}

// Authentication All
const authenAll = (liffID) => {
    return new Promise(async resolve => {
        // set url callback
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)

        // check line loggedin
        liff.init({
            liffId: liffID
        }).then(async() => {
            let accept_signin_policy = localStorage.getItem(process.env.REACT_APP_ENC_NAME_ACCEPT_SIGNIN_POLICY); // เคยกดยินยอมเงื่อนไขแล้ว
            let signin_response = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); // ถ้ามีเท่ากับเข้าสู่ระบบอยู่ จะใช้ตัวนี้ดึง api ต่อ แต่ถ้า expired แล้วจะต้องขึ้น session expired และให้บังคับ signin ใหม่
            let patient_data = localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA);
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            console.log('line profile: ', lineProfile);
            console.log('signin_response: ', signin_response);
            console.log('patient_data: ', patient_data);

            let isLineLoggedIn = liff.isLoggedIn();
            if(isLineLoggedIn) // login line แล้ว
            {
                if(!!lineProfile)
                {
                    if(!!signin_response && !!patient_data) // signin sso แล้ว
                    {
                        let isMemberLab = await isMembership();
                        if(isMemberLab)
                        {
                            let memberData = await getMemberLab();
                            let patient = DecryptedOBJ(patient_data)
                            console.log('patient: ', patient);
                            let jwt = await JWTAuthen(); // sso
                            let userRes = await SignInPhone(jwt, memberData.Phoneno); // sso
                            console.log('userRes: ', userRes);
                            if(userRes.isType === 1 || userRes.isType === 3)
                            {
                                localStorage.removeItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE);
                                localStorage.removeItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA);
                                setTimeout(() => {
                                    location.reload();
                                }, 500)
                            }else
                            {
                                resolve();
                            }
                        }else
                        {
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE);
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA);
                            setTimeout(() => {
                                location.reload();
                            }, 500)
                        }
                    }
                    else // ยังไม่ได้ signin sso
                    {
                        // navigate to check nhealth card membership & sso member
                        if(!!accept_signin_policy)
                        {
                            location.href = `${Base_API.pathWeb}/n-health/signin/checkmember`; // ข้าม policy ไปหน้า signin sso
                        }else
                        {
                            location.href = `${Base_API.pathWeb}/n-health/signin/policy`; // ไปหน้า policy ก่อน signin sso
                        }
                    }
                    // await checkUserInit(lineProfile, liffID)
                    // .then(() => {
                    //     if(!!signin_response && !!patient_data) // signin sso แล้ว
                    //     {
                    //         resolve();
                    //     }
                    //     else // ยังไม่ได้ signin sso
                    //     {
                    //         // navigate
                    //         if(!!accept_signin_policy)
                    //         {
                    //             location.href = `${Base_API.pathWeb}/n-health/signin/checkmember`; // ข้าม policy ไปหน้า signin sso
                    //         }else
                    //         {
                    //             location.href = `${Base_API.pathWeb}/n-health/signin/policy`; // ไปหน้า policy ก่อน signin sso
                    //         }
                    //     }
                    // })
                }else
                {
                    await useLineLogin(liffID); // ยังไม่ได้ login line
                    // set url callback
                    let currentURL = EncryptedText(location.href);
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)
    
                    // navigate
                    if(!!signin_response && !!patient_data) // signin sso แล้ว
                    {
                        resolve();
                    }
                    else // ยังไม่ได้ signin sso
                    {
                        // navigate to check nhealth card membership & sso member
                        if(!!accept_signin_policy)
                        {
                            location.href = `${Base_API.pathWeb}/n-health/signin/checkmember`; // ข้าม policy ไปหน้า signin sso
                        }else
                        {
                            location.href = `${Base_API.pathWeb}/n-health/signin/policy`; // ไปหน้า policy ก่อน signin sso
                        }
                    }
                }
            }else
            {
                await useLineLogin(liffID);
            }
        }).catch(async(error) => {
            console.error(error);
            await useLineLogin(liffID);
        });
    })
}

const checkUserInit = (lineProfile, liffID) => {
    return new Promise(async resolve => {
        console.log('Line Profile: ', lineProfile);

        if(!!lineProfile)
        {
            NhealthAction.GetMember(lineProfile.user_id)
            .then(async res => {
                console.log('Get Member: ', res.member);
                if(res.isSuccess === true)
                {
                    resolve();
                    // resolve(res.member);
                }else
                {
                    if(res.errMessage === 'not found !.')
                    {
                        // go to register member
                        // location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
                    }
                    // resolve(lineProfile.user_id);
                }
            })
        }else
        {
            await useLineLogin(liffID);
        }
    })
}

const getJWTbyPatientID = (patientID) => {
    return new Promise(async resolve => {
        let ip = await NhealthAction.GetIPAdress();
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;

        if(!!lineProfile)
        {
            let reqData = {
                UserRef: patientID,
                IPAddress: ip,
                Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
            } 
            NhealthAction.JWT_Authen(reqData)
            .then(res => {
                console.log('jwt: ', res)
                if(!!res)
                {
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                    resolve(res);
                }
            })
        }else
        {
            console.error('Line profile is required!');
        }

    })
}

const getJWT_Patient = () => {
    return new Promise(async resolve => {
        let ip = await NhealthAction.GetIPAdress();
        let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
        let patientID = patientData.data.patientid;
        console.log('patient: ',patientData);

        let reqData = {
            UserRef: patientID,
            IPAddress: ip,
            Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
        } 
        NhealthAction.JWT_Authen(reqData)
        .then(res => {
            console.log('jwt: ', res)
            if(!!res)
            {
                resolve(res);
            }
        })
    })
}

const updateKYCPatient = (refVerify) => {
    return new Promise(async (resolve, reject) => {
        let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
        let kycData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD)) : null;
        let isForeign = patientData.data.isForeign;
        let patientID = patientData.data.patientid;

        console.log('kyc data: ', kycData);
        console.log('dec regis info: ', patientData);

        if(!!kycData && !!patientData)
        {
            await identityVerification();
            await updatePatientProfile(kycData, refVerify, isForeign, patientID)
            .catch((statusCode) => {
                if(statusCode === 400 || statusCode === "400")
                {
                    reject("400_1");
                }
            });
            await updatePatientAddress(kycData, refVerify, isForeign, patientID)
            await updatePatientOccupation(kycData, refVerify, isForeign, patientID)
            await updatePatientMedicalInfo(kycData, refVerify, isForeign, patientID, patientData)
            await updatePatientMoreUploadfile(kycData, refVerify, isForeign, patientID, patientData)
            .catch((statusCode) => {
                if(statusCode === 400 || statusCode === "400")
                {
                    reject("400_2");
                }
            });
            await updatePatientIdentityImage(kycData, refVerify, isForeign, patientID)
            .then(() => {
                localStorage.removeItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_PAYLOAD);
                localStorage.removeItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_CITIZENID_INVALID);
                resolve();
            })
        }
    })
}

const identityVerification = () => {
    return new Promise(async resolve => {
        let faceRecogRes = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_OCR_HASH_SECRET) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_OCR_HASH_SECRET)) : null;
        let type_kyc = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS)) : null
        if(type_kyc==='idcard'){
            if(!!faceRecogRes){
                let formData = new FormData();
                formData.append('hashSecret', faceRecogRes);
                await NhealthAction.hashValidation(formData)
                .then(res => {
                    if(res.isSuccess){
                        resolve();
                    }else{
                        if(res.message === 'operation expired'){
                            ALERT.customAlert('ไม่สำเร็จ', 'การยืนยันตัวตนเกินระยะเวลาที่กำหนด', 'ตกลง', onBackToMyCard)
                        }else
                        {
                            ALERT.customAlert('ไม่สำเร็จ', 'การยืนยันตัวตนไม่สำเร็จ', 'ตกลง', onBackToMyCard)
                        }
                    }
                })
            }else
            {
                ALERT.customAlert('ไม่สำเร็จ', 'ไม่พบการยืนยันตัวตน', 'ตกลง', onBackToMyCard)
            }
        }else resolve();

        const onBackToMyCard = () => {
            localStorage.clear();
            const path = `${Base_API.pathWeb}/n-health/mycard` 
            window.location.href = path;
        }
    })
}

const updatePatientMoreUploadfile = (kycData, refVerify, isForeign, patientID, patientData) => {
    return new Promise(async (resolve, reject) => {
        let jwtData = await getJWT_Patient();
        let more_uplaod = kycData.more_uplaod;

        let rawReq = {
            "refEXP": refVerify.refEXP,
            "isType": refVerify.isType,
            "refAction": refVerify.refAction,
            "refType": refVerify.refType,
            "data": more_uplaod
        }
        let reqData = {
            "data": EncryptedOBJ(rawReq)
        }
        let headers = {
            token: jwtData.token,
            userRef: patientID,
            authorizeRef: jwtData.authorizeRef,
            channalRef: jwtData.channalRef
        }
        NhealthAction.updatePatientMoreUploadfile(reqData, headers)
        .then((res) => {
            if(res.IsSuccess)
            {
                if(res.statusCode === 400 || res.statusCode === '400')
                {
                    reject(res.statusCode);
                }else
                {
                    resolve();
                }
            }else
            {
                if(res.statusCode === 400 || res.statusCode === '400')
                {
                    reject(res.statusCode);
                }
            }
        })

    })
}
const updatePatientMedicalInfo = (kycData, refVerify, isForeign, patientID, patientData) => {
    return new Promise(async resolve => {
        let jwtData = await getJWT_Patient();
        let medical_info = patientData.data.medical_info;

        let rawReq = {
            "refEXP": refVerify.refEXP,
            "isType": refVerify.isType,
            "refAction": refVerify.refAction,
            "refType": refVerify.refType,
            "data": medical_info
        }
        let reqData = {
            "data": EncryptedOBJ(rawReq)
        }
        let headers = {
            token: jwtData.token,
            userRef: patientID,
            authorizeRef: jwtData.authorizeRef,
            channalRef: jwtData.channalRef
        }
        NhealthAction.updatePatientMedicalInfo(reqData, headers)
        .then((res) => {
            if(res.IsSuccess)
            {
                resolve();
            }
        })

    })
}
const updatePatientOccupation = (kycData, refVerify, isForeign, patientID) => {
    return new Promise(async resolve => {
        let jwtData = await getJWT_Patient();
        let occupation = kycData.occupation;

        let rawReq = {
            "refEXP": refVerify.refEXP,
            "isType": refVerify.isType,
            "refAction": refVerify.refAction,
            "refType": refVerify.refType,
            "data" :  {
                "occupation": occupation.occupation,
                "occupation_other": occupation.occupation_other,
                "income_per_month": occupation.income,
                "company_name": occupation.company_name,
                "address": occupation.company_address,
                "province": occupation.province,
                "district": occupation.district,
                "subdistrict": occupation.subdistrict,
                "postalcode": occupation.postcode
            }
        }
        let reqData = {
            "data": EncryptedOBJ(rawReq)
        }
        let headers = {
            token: jwtData.token,
            userRef: patientID,
            authorizeRef: jwtData.authorizeRef,
            channalRef: jwtData.channalRef
        }
        NhealthAction.updatePatientOccupation(reqData, headers)
        .then((res) => {
            if(res.IsSuccess)
            {
                resolve();
            }
        })

    })
}
const updatePatientAddress = (kycData, refVerify, isForeign, patientID) => {
    return new Promise(async resolve => {
        let jwtData = await getJWT_Patient();
        let address = kycData.address;
        let haveContactAddr = kycData.address.status_Current === 'true' ? true : false;
        let contactAddr = {
            "address": haveContactAddr ? kycData.contact_Address.address_Contact : "",
            "province": haveContactAddr ? kycData.contact_Address.province_Contact : "",
            "district": haveContactAddr ? kycData.contact_Address.district_Contact : "",
            "subdistrict": haveContactAddr ? kycData.contact_Address.subdistrict_Contact : "",
            "postalcode": haveContactAddr ? kycData.contact_Address.postalcode_Contact : ""
        }

        let rawReq = {
            "refEXP": refVerify.refEXP,
            "isType": refVerify.isType,
            "refAction": refVerify.refAction,
            "refType": refVerify.refType,
            "data" :  {
                "current_address": {
                    "address": address.address_Current,
                    "province": address.province_Current,
                    "district": address.district_Current,
                    "subdistrict": address.subdistrict_Current,
                    "postalcode": address.postalcode_Current
                },
                "contact_address": contactAddr
            }
        }
        let reqData = {
            "data": EncryptedOBJ(rawReq)
        }
        let headers = {
            token: jwtData.token,
            userRef: patientID,
            authorizeRef: jwtData.authorizeRef,
            channalRef: jwtData.channalRef
        }
        NhealthAction.updatePatientAddress(reqData, headers)
        .then((res) => {
            if(res.IsSuccess)
            {
                resolve();
            }
        })

    })
}
const updatePatientIdentityImage = (kycData, refVerify, isForeign, patientID) => {
    return new Promise(async resolve => {
        let jwtData = await getJWT_Patient();
        let iden_img =  !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL) ? localStorage.getItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL) : ""; 
        let ihuman_img = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_FACE_IMAGE_URL) ? localStorage.getItem(process.env.REACT_APP_ENC_NAME_FACE_IMAGE_URL) : "";
        console.log('iden img: ', iden_img);
        let rawReq = {
            "refEXP": refVerify.refEXP,
            "isType": refVerify.isType,
            "refAction": refVerify.refAction,
            "refType": refVerify.refType,
            "data" :  {
                "identity_id" : isForeign ? kycData.passport : kycData.cardid,
                "isForeign" : isForeign,
                "identity_image": iden_img,
                "ihuman_image": ihuman_img
            }
        }
        let reqData = {
            "data": EncryptedOBJ(rawReq)
        }
        let headers = {
            token: jwtData.token,
            userRef: patientID,
            authorizeRef: jwtData.authorizeRef,
            channalRef: jwtData.channalRef
        }
        NhealthAction.updatePatient_identity_image(reqData, headers)
        .then((res) => {
            if(res.IsSuccess)
            {
                resolve();
            }
        })
    })
}
const updatePatientProfile = (kycData, refVerify, isForeign, patientID) => {
    return new Promise(async (resolve, reject) => {
        let jwtData = await getJWT_Patient();
        let dob = String(kycData.dob).split('-')
        let gender = kycData.gender === 'male' ? 'M' : 'F'
        let marry = kycData.marry === 'single' ? 'S' : 'M'

        let rawReq = {
            "refEXP": refVerify.refEXP,
            "isType": refVerify.isType,
            "refAction": refVerify.refAction,
            "refType": refVerify.refType,
            "data" :  {
                "identity_id" : isForeign ? kycData.passport : kycData.cardid,
                "lasercode" : isForeign ? "" : kycData.passport,
                "isForeign" : isForeign,
                "name_th" : kycData.first_name_th,
                "surname_th" : kycData.last_name_th,
                "name_en" : kycData.first_name_en,
                "surname_en" : kycData.last_name_en,
                "dob_day" : Number(dob[0]),
                "dob_month" : Number(dob[1]),
                "dob_year" : Number(dob[2]),
                "gender" : gender,
                "phonenumber" : kycData.phone_number,
                "email" : kycData.email,
                "marry" : marry
            }
        }
        let reqData = {
            "data": EncryptedOBJ(rawReq)
        }
        let headers = {
            token: jwtData.token,
            userRef: patientID,
            authorizeRef: jwtData.authorizeRef,
            channalRef: jwtData.channalRef
        }
        NhealthAction.updatePatientProfile(reqData, headers)
        .then((res) => {
            if(res.IsSuccess)
            {
                if(res.statusCode === 400 || res.statusCode === '400')
                {
                    reject(400);
                }else
                {
                    resolve();
                }
            }else
            {
                if(res.statusCode === 400 || res.statusCode === '400')
                {
                    reject(400);
                }
            }
        })
    })
}

const getHeadersAuthenLineId = () => {
    return new Promise(async resolve => {
        let jwt = await JWTAuthen();

        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
        let udid = lineProfile.user_id;

        let headers = {
            token: jwt.token,
            userRef: udid,
            authorizeRef: jwt.authorizeRef,
            channalRef: jwt.channalRef
        }
        resolve(headers);
    })
}